export default "/assets/green-thumb-dark.svg";